var React = require('react');

function ScannerImage (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M0 320v128a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V288H32a32 32 0 0 0-32 32zm120 80a8 8 0 0 1-8 8H80a8 8 0 0 1-8-8v-32a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8zm96 0a8 8 0 0 1-8 8h-32a8 8 0 0 1-8-8v-32a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M617.84 220.84L36.31 32.83a16 16 0 0 0-20.25 10.1L.83 88.46a16 16 0 0 0 10.1 20.25L566.88 288H640v-36.71a32 32 0 0 0-22.16-30.45zM112 360H80a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8z","className":"fa-primary","key":2})]);
}

ScannerImage.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = ScannerImage;

ScannerImage.default = ScannerImage;
